import { CleanValuesOptions } from '@pogokid/schema'

export const cleanInvoiceLineOptions: CleanValuesOptions = {}
